export const FI_USERS_WRAPPER_TAG_NAME = 'tm-bo-fi-users-wrapper';
export const FI_USER_LIST_TAG_NAME = 'tm-bo-fi-user-list';
export const FI_USER_PROFILE_TAG_NAME = 'fi-user-profile';
export const FI_USER_ROLES_TAG_NAME = 'fi-user-roles';
export const FI_USER_ROLES_WRAPPER_TAG_NAME = 'fi-user-roles-wrapper';
export const FI_USER_ROLE_TAG_NAME = 'tm-bo-fi-user-role';
